import React, { Component } from 'react';
import TableProducts from './TableProducts';
import GridProducts from './GridProducts';
import ProductList from './ProductList';
import IconButton from '@material-ui/core/IconButton';
import ViewListIcon from '@material-ui/icons/ViewList';
import ViewComfyIcon from '@material-ui/icons/ViewComfy';
import FormatListNumberedRtlIcon from '@material-ui/icons/FormatListNumberedRtl';
import { withTranslation, Trans, withNamespaces } from 'react-i18next';
// import '../css/style.css';
import '../css/results-renderer-style.css';
import '../css/style-anniversary.css';
import '../css/style-blackfriday.css';
import '../css/style-specialoffer.css';
import '../css/style-stockclearance.css';
import '../css/style-promotion.css';
import $ from 'jquery';
import EventEmitter from '../event';
import axios from 'axios';
import { CUSTOM_SEARCH_BAR } from "./partials/constants";

class App extends Component {
  constructor(props) {
    super(props);
    this.source = axios.CancelToken.source();
    this.state = {
      familySortOnInit: this.props.familySortOnInit || false,
      showAddToCart: this.props?.showAddToCart,
      showAddToList: this.props?.showAddToList,
      from: this.props?.from,
      typeView: this.props.typeView,
      data: this.props.data,
      lang: this.props.lang,
      logged: this.props.logged,
      express: this.props.express,
      tariff: this.props.tariff,
      sortDirection: this.props.sortDirection,
      sortField: this.props.sortField,
      price_sort: this.props.price_sort,
      current: this.props.current,
      current_page: this.props.current_page,
      setCurrent: this.props.setCurrent,
      changed: false,
      addFilter: this.props.addFilter,
      clearFilter: this.props.clearFilter,
      family: this.props.family,
      family_list: this.props.family_list,
      isFamilyFlag: false,
      searchMode: this.props.searchMode,
      resultSearchTerm: this.props.resultSearchTerm,
      customFilterManufacturer: this.props.customFilterManufacturer,
      customFilterManufacturerIds: this.props.customFilterManufacturerIds,
      client_country_id: this.props.client_country_id,
      cart_products: this.props.cart_products,
      fav_products: this.props.fav_products,
      jwt: this.props.jwt,
      elementId: this.props.elementId,
      api_origin: this.props.api_origin,
      api_url: this.props.api_url,
      stocks: this.props.stocks || []     
    };
    this.getCartData = this.getCartData.bind(this);
    this.getStockData = this.getStockData.bind(this);
    this.sectionGetHeight = this.sectionGetHeight.bind(this);
  }

  sectionGetHeight = (height) => {
    this.props.mainHeight(height);
  };

  getView() {
    let result;
    const {
      showAddToCart,
      from,
      showAddToList,
      typeView,
      data,
      logged,
      isFamilyFlag,
      express,
      lang,
      tariff,
      sortDirection,
      sortField,
      price_sort,
      family_list,
      client_country_id,
      cart_products,
      fav_products,
      api_url,
      api_origin,
      jwt,
      elementId, 
      stocks,
      customFilterManufacturerIds,
      customFilterManufacturer
    } = this.state;

    switch (typeView) {
      case "grid":
        result = data.length > 0 && (
          <GridProducts
            rows={data}
            lang={lang}
            logged={logged}
            express={express}
            tariff={tariff}
            price_sort={price_sort}
            sectionHeight={(data) => this.sectionGetHeight(data)}
            client_country_id={client_country_id}
            cart_products={cart_products}
            fav_products={fav_products}
            jwt={jwt}
            api_origin={api_origin}
            api_url={api_url}
            stocks={stocks}
            customFilterManufacturerIds={customFilterManufacturerIds}
            customFilterManufacturer={customFilterManufacturer}

          />
        );
        break;
      case "table":
        result =
          data.length > 0 && from === CUSTOM_SEARCH_BAR ? (
            <TableProducts
              from={from}
              showSelectButton={this.props?.showSelectButton}
              showPlusButton={this.props?.showPlusButton}
              showPlusQtyButton={this.props?.showPlusQtyButton}
              handleSelectedProductClick={
                this.props?.handleSelectedProductClick
              }
              onProductSelected={this.props?.onProductSelected}
              showAddToCart={showAddToCart}
              showAddToList={showAddToList}
              data={data}
              rows={data}
              resultsFields={this.props?.resultsFields}
              lang={lang}
              logged={logged}
              express={express}
              tariff={tariff}
              sortDirection={sortDirection}
              sortField={sortField}
              price_sort={price_sort}
              familyData={family_list}
              isFamilyFlag={isFamilyFlag}
              client_country_id={client_country_id}
              cart_products={cart_products}
              fav_products={fav_products}
              jwt={jwt}
              elementId={elementId}
              api_origin={api_origin}
              api_url={api_url}
              openProduct={this.props?.openProduct}
              openOn={this.props?.openOn}
              selectedProductsCode={this.props?.selectedProductsCode}
              onProductAddedToCart={this.props?.onProductAddedToCart}
              onProductDeletedFromCart={this.props?.onProductDeletedFromCart}
              onProductQtyModifiedOnCart={
                this.props?.onProductQtyModifiedOnCart
              }
              onProductAddedToList={this.props?.onProductAddedToList}
              stocks={stocks}
              customFilterManufacturerIds={customFilterManufacturerIds}
              customFilterManufacturer={customFilterManufacturer}
            />
          ) : (
            <TableProducts
              rows={data}
              lang={lang}
              logged={logged}
              express={express}
              tariff={tariff}
              sortDirection={sortDirection}
              sortField={sortField}
              price_sort={price_sort}
              familyData={family_list}
              isFamilyFlag={isFamilyFlag}
              client_country_id={client_country_id}
              cart_products={cart_products}
              fav_products={fav_products}
              jwt={jwt}              
              api_origin={api_origin}
              api_url={api_url}
              stocks={stocks}
              customFilterManufacturerIds={customFilterManufacturerIds}
              customFilterManufacturer={customFilterManufacturer}
            />
          );
        break;
      case "list":
        result = data.length > 0 && (
          <ProductList
            rows={data}
            lang={lang}
            logged={logged}
            express={express}
            tariff={tariff}
            price_sort={price_sort}
            client_country_id={client_country_id}
            cart_products={cart_products}
            fav_products={fav_products}
            jwt={jwt}
            api_origin={api_origin}
            api_url={api_url}
            stocks={stocks}
            customFilterManufacturerIds={customFilterManufacturerIds}
            customFilterManufacturer={customFilterManufacturer}
          />
        );
        break;
    }
    return result;
  }

  handleChangeView(typeView) {
    this.setState({
      typeView: typeView,
    });
    this.props.onChangeView(typeView);
  }

  calcNetPrice(row) {
    const { tariff } = this.state;
    let pvp = parseFloat(row?.parsed_tariffs?.raw[tariff]?.p.replace(/,/g, ""));
    let discount = parseFloat(
      row?.parsed_tariffs?.raw[tariff]?.d.replace(/,/g, "")
    );

    let net_price = pvp;
    if (!isNaN(pvp) && !isNaN(discount)) {
      net_price = pvp - (pvp * discount) / 100;
    }
    return net_price;
  }

  checkReferenceMatching(data, resultSearchTerm) {
    const { tariff } = this.state;
    let resultSearchTermFiltered = resultSearchTerm
      .replace(/[^0-9a-z]/gi, "")
      .toLowerCase();

    if (data.length > 0) {
      
      
      for (const row of data) {
        if (
          Object.hasOwnProperty.call(row, "ref1") &&
          Object.hasOwnProperty.call(row, "ref1f") &&
          Object.hasOwnProperty.call(row.ref1, "raw") &&
          Object.hasOwnProperty.call(row.ref1f, "raw")
        ) {
          if (
            resultSearchTerm == row.ref1.raw ||
            resultSearchTermFiltered == row.ref1f.raw.toLowerCase()
          ) {
            row.highlight = 1;
          }
        }
        
      }
    }

    this.setState({
      data: data,
    });
  }

  getCartData = async () => {
    if(this.state.logged){
      let newURL = this.state.api_url+'/carts';
      const cartProducts = await axios.get(newURL, {
        headers: { 
          "Content-type": "application/json",
          "Authorization": this.state.jwt,        
        },
        method: "GET",
      });
      
      /*if(cartProducts){
        console.log("Asd");
      }*/
    }
  };

  getStockData = async (products) => {
    if(this.state.logged){
      if (products.length > 0) {

         // Cancelar la solicitud anterior si existe
         if(this.source){
          this.source.cancel();
        }
        
        this.source = axios.CancelToken.source();

        let newURL = this.state.api_url+'/product-inventories?select=product_id,stock&products='+products;
        const stockProducts = await axios.get(newURL, {
          headers: { 
            "Content-type": "application/json",
            "Authorization": this.state.jwt,        
          },
          method: "GET",          
          cancelToken: this.source.token // Pasar el token de cancelación a la configuración de la solicitud
        }).catch(function (thrown) {
          if (axios.isCancel(thrown)) {
            console.log('Request canceled', thrown.message);
          } else {
            console.log("cancel error")
          }
         });
        
        
        if(stockProducts && stockProducts?.data && stockProducts.data?.data) {
          this.setState({stocks:[...stockProducts.data.data]});
          this.parsePricesAndStock();
        }
      }
    }    
  }

  getFromStocks(id, stocks, field) {
    let value = 0;
    if (stocks && stocks.length > 0) {
      for (const stock of stocks) {
        if (stock.product_id === parseInt(id)) {
          if (Object.hasOwnProperty.call(stock, field)) {
            value = stock[field];
          }
          break;
        }
      }
    }
    return value;
  }

  

  parsePricesAndStock() {
    const { data, stocks } = this.state;
    let found = false;

    if (data.length > 0) {
      for (const row of data) {
    
        if (Object.hasOwnProperty.call(row, "id") && Object.hasOwnProperty.call(row.id, "raw")) {
          let id = row.id.raw;
          if (stocks && stocks.length > 0) {
            let stock = this.getFromStocks(id, stocks, "stock");
            let net = this.getFromStocks(id, stocks, "net");
            let price = this.getFromStocks(id, stocks, "price");
            let in_offer = this.getFromStocks(id, stocks, "in_offer");
            let in_offer_until = this.getFromStocks(id, stocks, "in_offer_until");
            let currency = this.getFromStocks(id, stocks, "currency");
            
            row.stock = stock;
            row.net = net;
            row.price = price;
            row.in_offer = in_offer;
            row.in_offer_until = in_offer_until;
            row.currency = currency;
            found = true;
          }
        }
      }  
    }
    
    if(found) {
      this.setState({
        data: data,
      });
    }
  }

  addEngineToURL() {
    const { family, typeView, searchMode } = this.state;
    let actualFamily = family;
    if (actualFamily == null) {
      actualFamily = "";
    }
    setTimeout(function () {
      const url = new URL(window.location.href);
      url.searchParams.set("search_mode", searchMode);
      url.searchParams.set("engine", actualFamily);
      url.searchParams.set("view", typeView);
      //window.history.replaceState(null, null, url);
    }, 2000);
  }

  

  componentDidMount() {
    if (this.state.from === CUSTOM_SEARCH_BAR) {
      const { resultSearchTerm } = this.props;
      this.checkReferenceMatching(this.props.data, resultSearchTerm);
      this.getCartData();
      let products = this.props.data.map(obj => obj.id.raw);
      if(products.length>0) {
        this.getStockData(products);
      }
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const category = urlParams.get("category");
      let url = new URL(window.location.href);
      url.searchParams.set("view", this.props.typeView);
    } else {
      const { resultSearchTerm } = this.props;
      this.checkReferenceMatching(this.props.data, resultSearchTerm);
      this.getCartData();
      let products = this.props.data.map(obj => obj.id.raw);
      if(products.length>0) {
        this.getStockData(products);
      }
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const category = urlParams.get("category");
      let url = new URL(window.location.href);
      url.searchParams.set("view", this.props.typeView);
      const { searchMode, addFilter, clearFilter } = this.state;

      if (this.props.sortField !== "") {
        if (this.props.sortField == "main_family") {
          this.setState({
            isFamilyFlag: true,
          });
        } else {
          this.setState({
            isFamilyFlag: false,
          });
        }
      }

      if (this.props.typeView !== "") {
        this.setState({
          typeView: this.props.typeView,
        });
      }

      if (searchMode != "id") {
        if (category != "id") {
          // Cargar filtros por defecto
          addFilter("not_discontinued", "true", "any");
          // addFilter("main_color", "true", "any");
        }
      } else {
        clearFilter();
      }
    }
  }

  componentWillUnmount() {
    // Cancelar la solicitud anterior si existe
    if(this.source){
      this.source.cancel();
    }
  }

  componentDidUpdate(prevProps) {
    const { resultSearchTerm } = this.props;
    
    // Formatear JSON de tarifas
    if (this.props.data !== prevProps.data) {
      
      this.checkReferenceMatching(this.props.data, resultSearchTerm);
      let products = this.props.data.map(obj => obj.id.raw);
      if(products.length>0) {
        this.getStockData(products);
      }
      /*const stocksTemp = await       
      this.setState({stocks: stocksTemp});*/            
    }

    if(this.props.resultSearchTerm !== prevProps.resultSearchTerm) {
      if(this.state.familySortOnInit) {          
          this.setState({
            familySortOnInit: false
          });
          this.props.setDefaultOrder();          
      }
    }

    if (this.state.from !== CUSTOM_SEARCH_BAR) {
      const { current_page, current, setCurrent, changed } = this.state;

      // Actualizar en state y comprobar la página actual
      if (prevProps.current != this.props.current) {
        this.setState({ current: this.props.current });
      }

      if (!changed && current_page > 1) {
        if (current_page > 1) {
          setCurrent(current);
        } else {
          setCurrent(current_page);
        }
        this.setState({ changed: true });
      }

      if (prevProps.sortField != this.props.sortField) {
        if (this.props.sortField !== "") {
          if (this.props.sortField == "main_family") {
            this.setState({
              isFamilyFlag: true,
            });
          } else {
            this.setState({
              isFamilyFlag: false,
            });
          }
        }
      }

      if (prevProps.typeView != this.props.typeView) {
        if (this.props.typeView !== "") {
          this.setState({
            typeView: this.props.typeView,
          });
        }
      }

      if (prevProps.sortField != this.props.sortField) {
        if (
          this.props.sortField == "" ||
          this.props.sortField == "stock" ||
          this.props.sortField == "webcode" ||
          this.props.sortField == "topsales" ||
          this.props.sortField == "entry_date"
        ) {
          this.props.onSortChange("change", "desc");
          //EventEmitter.disptach('heightData',true);
        } else {
          this.props.onSortChange("change", "asc");
          //EventEmitter.disptach('heightData',true);
        }
      }

      if (prevProps.searchMode != this.props.searchMode) {
        if (this.props.searchMode == "id") {
          this.state.clearFilter();
          let actualFamily = "";
          const url = new URL(window.location.href);
          url.searchParams.set("engine", actualFamily);
          window.history.replaceState(null, null, url);
        }
      }
    }

    // Añadir a la URL parametro con el engine actual usado en la búsqueda
    this.addEngineToURL();
  }

  render() {
    const { data, stocks } = this.state;

    let result = this.getView();
    if (localStorage.getItem("pinStatus") === null)
      localStorage.setItem("pinStatus", "open");
    return <div className="SearchResult">
      {result}
      </div>;
  }
}

App.defaultProps = {
  from: false,
};
export default withTranslation()(App);
